import type { RouteRecordRaw } from 'vue-router'

const voicemailRoutes: RouteRecordRaw = {
  path: '/voicemail',
  name: 'voicemail',
  meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'common.titles.voicemail' },
  component: () => import('@/pages/voicemail/VoicemailPage.vue'),
}

export default voicemailRoutes
